import { IconX } from 'featherico';
import { get } from 'lodash/fp';
import { AriaAnnouncer, AriaLabel } from '../../../components/AriaHelper';
import Button from '../../../components/Button';
import Spinner from '../../../components/Spinner';
import { getCurrentUser } from '../../../services/CurrentUser';
import { CYCLE, TEAM, createQuery, getPages } from '../../../services/HeaderSearchBar';
import { modulo } from '../../../services/Math';
import { hasBasicHr, isManager } from '../../../services/User';
import headerStyles from '../style.m.less';
import styles from './style.m.less';

export default function SearchInput({ ref, query, status, mode, selectedItem, items, actions }) {
    return (
        <div className={headerStyles.searchInput}>
            {mode === 'SEARCH' && (
                <AriaAnnouncer id="header_search_bar-description">
                    {items.length === 1 ? 'There is 1 result.' : `There are ${items.length} results.`} Use arrow keys to
                    navigate results.
                </AriaAnnouncer>
            )}
            <AriaLabel id="header_search_bar-label">Type to quickly jump to users or cycles</AriaLabel>
            <input
                ref={ref}
                aria-label={get('value.plainValue', items[selectedItem])}
                aria-autocomplete="none"
                aria-owns="header_search_bar-result"
                aria-activedescendant="header_search_bar-result--selected-item"
                aria-labelledby="header_search_bar-label"
                aria-describedby="header_search_bar-description"
                type="text"
                value={query}
                onChange={onQueryChange}
                onKeyDown={onKeyPress}
                id="header_search_bar-search_input-input"
                className={headerStyles.input}
                autoComplete="off"
                placeholder="Find user or cycle"
            />
            <div className={headerStyles.searchInputIcon}>{getIcon(status, onHideClick)}</div>
        </div>
    );

    function onQueryChange(ev) {
        const newQuery = ev.target.value;
        if (query === newQuery) {
            return false;
        }

        actions.doUpdateQuery(newQuery);
        if (newQuery !== '') {
            actions.debouncedSearch(newQuery);
        } else {
            actions.debouncedSearch.cancel();
            actions.search(createQuery(TEAM, getCurrentUser()));
        }
    }

    function onHideClick(ev) {
        ev.preventDefault();
        actions.doUpdateQuery('');
        actions.doClearResult();
        actions.doHideResults();
    }

    function onKeyPress(ev) {
        const LEFT = 37;
        const RIGHT = 39;
        const UP = 38;
        const DOWN = 40;
        const ENTER = 13;
        const ESC = 27;

        const handler =
            {
                [LEFT]: onLeftPress,
                [RIGHT]: onRightPress,
                [UP]: onUpPress,
                [DOWN]: onDownPress,
                [ENTER]: onEnterPress,
                [ESC]: onEscPress,
            }[ev.keyCode] || (x => x);

        handler(ev);
    }

    function onLeftPress() {
        if (mode === 'SEARCH' || !isAllowedToSeeCycles(getCurrentUser())) {
            return;
        }

        getOtherMode(mode);
        if (selectedItem !== null) {
            actions.doSelectItem(0);
        }
    }

    function onRightPress() {
        if (mode === 'SEARCH' || !isAllowedToSeeCycles(getCurrentUser())) {
            return;
        }

        getOtherMode(mode);
        if (selectedItem !== null) {
            actions.doSelectItem(0);
        }
    }

    function isAllowedToSeeCycles(user) {
        return hasBasicHr(user) || isManager(user);
    }

    function onUpPress(ev) {
        ev.preventDefault();
        actions.doSelectPrevItem();
    }

    function onDownPress(ev) {
        ev.preventDefault();
        actions.doSelectNextItem();
    }

    function onEnterPress(ev) {
        if (selectedItem === null) {
            return;
        }

        const pages = getPages(mode, items);
        const totalNumberOfItems = pages.length + items.length;
        const allItems = items.concat(pages);
        const index = modulo(selectedItem, totalNumberOfItems);

        ev.preventDefault();
        actions.doHideResults();
        actions.doRedirect(allItems[index].value.url);
    }

    function onEscPress() {
        actions.doUpdateQuery('');
        actions.doSelectItem(null);
        actions.doHideResults();
    }

    function getOtherMode(currentMode) {
        if (currentMode !== 'TEAM') {
            actions.search(createQuery(TEAM, getCurrentUser()));
        } else {
            actions.search(createQuery(CYCLE));
        }
    }
}

function getIcon(status, onHideClick) {
    if (status === 'LOADED') {
        return (
            <Button
                kind="PLAIN"
                tabIndex="-1"
                onClick={onHideClick}
                className={styles.clearButton}
                aria-label="Cancel search"
                eventTracking={{ category: 'navigation header search bar', action: 'click close' }}
            >
                <IconX />
            </Button>
        );
    } else if (status === 'LOADING') {
        return <Spinner isSpinning={true} />;
    }
}
